import * as hf from "./_hf";
import * as ht from "./_ht";
import * as cv from "./_cv";

import { a } from "./_csAbt";

export const atrAbtz: ht.dz = { // avatar
  nmlz: () => ({
    boxStlz: a("dh/6 dw/6 br/3"),
    textCz: {
      textz: {
        stlz: a("tc/lt1 tb"),
      },
    },
  })
};

/*
export const barAbtz: ht.dz = {

  nmlz: () => ({
    boxStlz: undefined,
    bfrCz: {
      boxStlz: undefined,
    },
    ctrCz: {
      boxStlz: undefined,
    },
    atrCz: {
      boxStlz: undefined,
    },
  }),

  ftrCmnz: () => ({
    boxStlz: a('dw/f'),
    ctrCz: {
      boxStlz: a('dw/f fd/rac pv/1'),
    },
  }),

  hdrCmnz: () => ({
    boxStlz: a(`dh/hdr dw/f fd/rsc sc/lt7`),
  }),

  bdyCmnz: () => ({
    boxStlz: a('dh/f dw/f fd/rss'),
    bfrCz: {
      boxStlz: a('dh/f'),
    },
    ctrCz: {
      boxStlz: a('dh/f f/1'),
    },
  }),

};
*/

export const boxAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("fd/css"),
  }),
  listCmnz: () => ({
    boxStlz: a('dh/f dw/30 fd/csc pt/1 sc/lt8'),
  }),
};

export const brdAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a('dw/f fd/csc'),
    ttlCz: {
      boxStlz: a('dw/f'),
      textz: {
        stlz: a('tb'),
      },
    },
    dtlCz: {
      boxStlz: a('dw/f'),
    }
  }),
};


export const btnAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: undefined,
    lblCz: {
      boxStlz: undefined,
      textz: {
        pfx: undefined,
        stlz: undefined,
      }
    },
  }),

  _ctdz: (pz?: { // contained
    br?: ht.n,
    dw?: ht.n,
    fd?: ht.s,
    icn?: ht.s,
    pv?: ht.n,
    sc?: ht.s,
    tc?: ht.s,
    ts?: ht.s,
  }) => {
    const _br = pz?.br ?? 1;
    const _dw = pz?.dw ?? 10;
    const _fd = pz?.fd ?? 'ccc';
    const _icn = pz?.icn;
    const _pv = pz?.pv ?? 1;
    const _sc = pz?.sc ?? 'lt6';
    const _tc = pz?.tc ?? 'lt1';
    const _ts = pz?.ts ?? 'm';
    return { // status
      boxStlz: a(`br/${_br} dw/${_dw} fd/${_fd} pv/${_pv} sc/${_sc}`),
      lblCz: {
        textz: {
          stlz: a(`tb tc/${_tc} ts/${_ts}`)
        }
      },
      bfrIconCz: 
        _icn ?
        {
          iconPtyz: a(`icc/lt1 icn/${_icn} ics/2`)
        }
        : undefined,
    };
  },

  _addz: (pz: {
    sc?: ht.s
    tc?: ht.s
  }) => {
    const _sc = pz?.sc ?? 'lt9';
    const _tc = pz?.tc ?? 'lt1';
    return { // status
      boxStlz: a(`br/0.5 fd/rac pv/0.5 ph/1 sc/${_sc}`),
      lblCz: {
        boxStlz: a(`pl/1`),
        textz: {
          pfx: '追加',
          stlz: a(`tb tc/${_tc} ts/s`),
        }
      },
      bfrIconCz: {
        iconPtyz: a(`icc/${_tc} icn/plus ics/2`),
      }
    };
  },

  _cfmCmnz: (pDz: {
    ccd1: ht.s,
    ccd2: ht.s,
  }) => ({ // confirm
    boxStlz: a(`br/0.5 dw/10 fd/rac pv/0.5 ph/1 sc/${pDz.ccd1 ?? 'lt7'}`),
    lblCz: {
      textz: {
        pfx: '確認',
        stlz: a(`ta/c tc/${pDz.ccd2 ?? 'lt1'} tb`),
      }
    },
    bfrIconCz: {
      iconPtyz: a(`icc/${pDz.ccd2 ?? 'lt1'} ics/2.5`),
    }
  }),

  _ctdCmnz: (pz?: { // contained square
    br?: ht.n,
    sc?: ht.s, // ccd1
    tc?: ht.s, // ccd2
    dh?: ht.n,
    dw?: ht.n,
  }) => {
    const _br = pz?.br ?? 1;
    const _dh = pz?.dh ?? 4;
    const _dw = pz?.dw ?? 36;
    const _sc = pz?.sc ?? 'rd9';
    const _tc = pz?.tc?? 'lt1';
    return { // staff futter next
      boxStlz: a(`br/${_br} dh/${_dh} dw/${_dw} fd/ccc sc/${_sc}`),
      lblCz: {
        textz: {
          stlz: a(`ta/c tb tc/${_tc} ts/m`)
        }
      },
    }
  },

  _dltz: (pz?: {
    sc?: ht.s
    tc?: ht.s
  }) => {
    const _sc = pz?.sc ?? 'lt9';
    const _tc = pz?.tc ?? 'lt1';
    return { // delete
      boxStlz: a(`br/0.5 dw/9 fd/rac mh/a pv/0.5 ph/1 sc/${_sc}`),
      lblCz: {
        textz: {
          pfx: '削除',
          stlz: a(`pl/0.5 ta/c tc/${_tc} tb ts/s`),
        }
      },
      bfrIconCz: {
        iconPtyz: a(`icc/${_tc} icn/trash ics/2`),
      }
    }
  },

  _homeCmnz: (pz: { ccd: ht.s, dh: ht.n, dw: ht.n }) => ({ // staff home #2
    boxStlz: a(`br/1 dh/${pz.dh ?? 12} dw/${pz.dw ?? 24} fd/ccc sc/${pz.ccd}`),
    lblCz: {
      textz: {
        stlz: a('tb tc/lt1 ts/l')
      }
    },
  }),

  editCmnz: () => ({
    boxStlz: a('br/1 dw/36 fd/rcc sc/lt1 pv/0.5'),
    lblCz: {
      boxStlz: a('fd/ccc pl/1'),
      textz: {
        stlz: a('tb tc/lt9 ts/m'),
      },
    },
    bfrIconCz: {
      iconPtyz: a('icc/lt9 icn/pencil ics/2.5'),
    }
  }),

  leftIconz: () => ({
    boxStlz: a('fd/rsc'),
    lblCz: {
      boxStlz: a('pl/1'),
      textz: {
        pfx: undefined,
        stlz: undefined,
      }
    },
  }),

  rhtIconz: () => ({
    boxStlz: a('fd/rec'),
    lblCz: {
      boxStlz: a('pr/1'),
      textz: {
        pfx: undefined,
        stlz: undefined,
      }
    },
  }),

  schCmnz: () => ({ // seach
//    boxStlz: a('fd/rsc pl/1'),
    boxStlz: a('br/0.5 fd/rsc ph/1 pv/0.5 sc/gn6'),
    lblCz: {
      textz: {
        pfx: '検索',
        stlz: a('tb tc/lt1 ts/s pl/0.5')
      }
    },
    bfrIconCz: {
      iconPtyz: a('icc/lt1 icn/search ics/2.5')
    }
  }),

  tabCmnz: () => ({
    boxStlz: a('brt/1.5 ml/1 pv/0.5 ph/2 sc/lt7'),
    lblCz: {
      boxStlz: a('dw/f fd/ccc'),
      textz: {
        stlz: a('tb tc/lt1 ts/m'),
      },
    }
  }),
};


export const cbxAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("fd/rsc"),
    cbxCz: {
      boxStlz: {
        sctz: a("dh/3 dw/3"),
        nmlz: a("dh/3 dw/3"),
      },
      iconPtyz: {
        sctz: a("icn/check-square-o ics/3"),
        nmlz: a("icn/square-o ics/3"),
      },
    },
    lblCz: {
      boxStlz: {},
      textz: {
        stlz: a("dh/3 ts/2 pl/0.5"),
        ptyz: {},
      },
    },
  }),
};

export const cbxMmAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("fd/rsc fw/w"),
    lz: {
      boxStlz: a("pr/4"),
    },
  }),
};

export const cdrAbtz: ht.dz = {
  mdlCmnz: () => ({
    boxStlz: a('dh/f dw/f'),
    hdrCz: {
      boxStlz: a('dh/6 dw/f f/n fd/rac mb/0'),
    },
    bdyCz: {
      boxStlz: a('bc/lt9 bwt/1 bwr/1 f/1'),
      dowCz: {
        boxStlz: a('dh/4 dw/f f/n mb/0 pb/0'),
        textCz: {
          boxStlz: {
//            '日': a('bc/lt9 bwb/1 bwl/1 dh/4 dw/f fd/ccc mb/0 sc/lt3'),
//            '土': a('bc/lt9 bwb/1 bwl/1 dh/4 dw/f fd/ccc mb/0 sc/lt2'),
            '日': a('bc/lt9 bwb/1 bwl/1 dh/4 dw/f fd/ccc mb/0 sc/rd4'),
            '土': a('bc/lt9 bwb/1 bwl/1 dh/4 dw/f fd/ccc mb/0 sc/rd1'),
            '他': a('bc/lt9 bwb/1 bwl/1 dh/4 dw/f fd/ccc mb/0 sc/lt1')
          }
        }
      },
      dtmCz: {
        boxStlz: a('dw/f dh/f f/1 mb/0'),
        btnCz: {
          lblCz: {
            boxStlz: {
//              '日': a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt3'),
//              '土': a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt2'),
              '日': a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/rd4'),
              '土': a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/rd1'),
              '他': a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt1'),
              '外': a('bc/lt9 bwb/1 bwl/1 dh/f dw/f fd/ccc sc/lt4'),
            },
            textz: {
              stlz: {
                '同': a('tc/lt9'),
                '違': a('tc/lt5'),
              }
            }
          }
        }
      }
    }
  })
};

export const ennAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("sc/t f/1 dw/55 pb/1 p/1 fd/css"),
    cttC: {
      boxStlz: {},
    },
    ennCz: {
      boxStlz: {},
      textz: {
        stlz: {},
      },
    },
  }),
};

export const fldAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("sc/t f/1 dw/55 pb/1 p/1 fd/css"),
    mainz: {
      boxStlz: a("sc/t dh/6 dw/f fd/rss"),
      lblCz: lblAbtz.nmlz(),
    },
    subz: {
      boxStlz: a('dw/f sc/rd5'),
      msgCz: {
        boxStlz: a('sc/rd3'),
        textz: {
          stlz: a("ts/xs tc/lt5 sc/rd1"),
        },
      },
    },
  }),
};

export const ftrAbtz: ht.dz = {
};

export const gridAbtz: ht.dz = {

  nmlz: () => ({
    boxStlz: a('bc/lt9 bw/0 bwr/1 bwt/1 dw/f fd/css'),
    lineCz: ( _nListIdx: ht.n ) => ({
      boxStlz: a('fd/rss dw/f'),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: a('bc/lt9 bw/0 bwl/1 bwb/1 fd/ccc'),
      })
    })
  }),

  _barz: (pz?: { // bar
    dh?: ht.s | ht.n,
    fd?: ht.s,
    pv?: ht.n,
    sc?: ht.s,
  }) => {
    const _dh = pz?.dh ?? 'n';
    const _fd = pz?.fd ?? 'rbc';
    const _pv = pz?.pv ?? 0.5;
    const _sc = pz?.sc ?? 't';
    return {
      boxStlz: a(`dh/${_dh} dw/f pt/${_pv} sc/${_sc}`),
      lineCz: ( _nLineIdx: ht.n ) => ({
        boxStlz: 
          a(`dw/f fd/${_fd}`),
        cellCz: ( _nCellIdx: ht.n ) => ({
          boxStlz:
  //          a('fd/rsc pb/0.5 ph/1')
            a(`fd/rsc pb/${_pv}`)
        })
      })
    }
  },

  _brdz: (pz: { // board
    br?: ht.n,
    ccd1: ht.s,
    ccd2: ht.s,
    ccd3: ht.s,
  }) => ({
//    boxStlz: a(`br/${pz.br ?? 0} dw/f f/1 fd/cac mh/a ph/1 pb/1 sc/${pz.ccd}`),
//    boxStlz: a(`bc/${pz.ccd3} bw/1 dw/f f/1 fd/cac mh/a`),
    boxStlz: a(`bc/${pz.ccd3} bw/2 dw/f fd/cac mh/a`),
    lineCz: ( _nLineIdx: ht.n ) => ({
      boxStlz: 
        _nLineIdx == 0 ?
          a(`dw/f fd/cac pv/0.5 ph/1 sc/${pz.ccd1}`)
        : a(`dw/f fd/cac pv/0.5 ph/1 sc/${pz.ccd2}`),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: undefined
      })
    })
  }),

  _tblBdyz: (pz?: {
    bc?: ht.s,
    bw?: ht.n,
    mb?: ht.n,
    ph?: ht.n,
  }) => {
    const _bc = pz?.bc ?? 'lt9'; // or t
    const _bw = pz?.bw ?? 2.0; // 1.0 or 2.0
    const _mb = pz?.mb ?? 0.5; // 0.0 or 0.5 
    const _ph = pz?.ph ?? 1.0; // 0.0 or 1.0
    return { // table body
      boxStlz: a(`bc/${_bc} bwb/${_bw} dw/f`),
      lineCz: ( _nLineIdx: ht.n ) => ({
        boxStlz:
          a(`dw/f f/1 fd/rsc mb/${_mb} pl/${_ph}`),
        cellCz: ( _nCellIdx: ht.n ) => ({
//          boxStlz: a(`dh/f f/1 fd/rsc pr/${_ph}`)
          boxStlz: a(`dh/f f/1 fd/rsc pr/${_ph}`) // bdy は rsc, hdr は rcc
        })
      })
    }
  },

  _tblHdrz: (pz?: { 
    bc?: ht.s,
    bw?: ht.n,
    mb?: ht.n,
    ph?: ht.n,
  }) => {
    const _bc = pz?.bc ?? 'lt9'; // or t
    const _bw = pz?.bw ?? 2.0; // 1.0 or 2.0
    const _mb = pz?.mb ?? 0.5; // 0.0 or 0.5 
    const _ph = pz?.ph ?? 1.0; // 0.0 or 1.0
    return { // staff 
      boxStlz: a(`bc/${_bc} bwb/${_bw} dw/f mb/${_mb}`),
      lineCz: ( _nLineIdx: ht.n ) => ({
        boxStlz:
          a(`dw/f f/1 fd/rsc pl/${_ph}`),
        cellCz: ( _nCellIdx: ht.n ) => ({
          boxStlz: a(`f/1 fd/rcc pr/${_ph}`) // bdy は rsc, hdr は rcc
        })
      })
    }
  },

  _vclz: (pz: { // vertical
    dw: ht.s | ht.n,
  }) => ({
    boxStlz: a(`dw/${pz.dw} fd/csc`),
    lineCz: ( _nLineIdx: ht.n ) => ({
      boxStlz: a(`dw/f`),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: a('dw/f')
      })
    })
  }),

  appCmnz: () => ({
    boxStlz: a('dh/f dw/f fd/rss'),
    lineCz: ( _nLineIdx: ht.n ) => ({
      boxStlz: 
        _nLineIdx == 0 ?
          a('dh/f fd/css')
        : a('dh/f f/1 fd/css'),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz:
          _nLineIdx == 0 ?
            a('f/1')
          : _nLineIdx == 1 ?
            _nCellIdx == 0 ?
              a('dw/f pv/0.5 ph/1 sc/lt6')
            : _nCellIdx == 1 ?
              a('dw/f fd/rsc pt/0.5 sc/lt6')
            : _nCellIdx == 2 ?
              a('dw/f f/1 fd/csc')
            : undefined
          : undefined,
      }), 
    })
  }),

  cttHdrCmnz: () => ({
    boxStlz: a('dw/f ph/1 sc/lt6'),
    lineCz: ( _nListIdx: ht.n ) => ({
      boxStlz: 
        _nListIdx == 0 ?
          a('pv/0.5')
        : _nListIdx == 1 ?
          a('pt/0.5')
        : undefined,
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: a('fd/rsc'),
      })
    })
  }),

  homeCmnz: () => ({ // staff home
    boxStlz: a('dh/f dw/f dwx/120 f/1 fd/csc mh/a'),
    lineCz: ( _nLineIdx: ht.n ) => ({
      boxStlz: a('dw/f f/1 fd/rcc mb/1'),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: a('fd/ccc f/1')
      })
    })
  }),

  itemCmnz: () => ({
    boxStlz: a('dw/f fd/css'),
    lineCz: ( _nLineIdx: ht.n ) => ({
      boxStlz:
        _nLineIdx == 0 ?
          a('dw/f fd/rsc mb/0.5')
        : a('dw/f fd/rsc mb/0.5 pl/1'),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: 
          a('f/1'),
      }), 
    })
  }),

  listCmnz: () => ({
    boxStlz: a('dw/f fd/css ph/1'),
    lineCz: ( _nLineIdx: ht.n ) => ({
      boxStlz:
          _nLineIdx == 0 ? 
          a('bc/lt1 bwb/1 dw/f fd/rsc mb/1 pv/0.5 ph/1')
        : a('bc/lt6 bwl/4 dw/f fd/rsc mb/1 pv/0.5 ph/1 sc/lt7'),
      cellCz: ( _nCellIdx: ht.n ) => ({
        boxStlz: 
          a('f/1'),
      }), 
    })
  }),

};

export const hdgAbtz = {
  nmlz: () => ({
    boxStlz: a("dw/f bw/0 bc/lt4"),
    textz: {  
      stlz: a("dw/20 tb pv/1 ph/2 sc/lt4 tc/lt1 ta/c"),
    },
  }),
};

export const iconAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("dh/3 dw/3"),
    iconPtyz: a("icn/square-o ics/4 icc/lt5"),
}),
};

export const iptAbtz: ht.dz = { // showz は bc/t sc/t ioc/t
  nmlz: () => ({
    boxStlz: null,
    iptStlz: {
      editz: a("bc/lt3 br/1 bw/2 dh/4 dw/f p/1 sc/lt1 tc/lt9 ts/m ioc/lt3"),
      showz: a("bc/t br/1 bw/2 dh/4 dw/f p/1 sc/t tc/lt9 ts/m ioc/t"),
    },
  }),
  _oldz: (pz?: { // outlined
    bc?: ht.s,
    pv?: ht.n,
    ph?: ht.n,
    tc?: ht.s,
    ts?: ht.s,
  }) => {
    const _bc = pz?.bc ?? 'lt1';
    const _pv = pz?.pv ?? 0.5;
    const _ph = pz?.ph ?? 1.0;
    const _tc = pz?.tc ?? 'lt1';
    const _ts = pz?.ts ?? 'm';
    return {
      iptStlz: {
        editz: a(`bc/${_bc} br/0.5 bw/1 dw/f ioc/${_bc} ph/${_ph} pv/${_pv} sc/t tc/${_tc} ts/${_ts}`),
        showz: a(`bc/t br/0.5 bw/1 dw/f ioc/t ph/${_ph} pv/${_pv} sc/t tc/${_tc} ts/${_ts}`),
      }
    };
  },
  login: () => ({
    iptStlz: {
      editz: a("sc/lt1 dh/4 dw/f br/1 bw/1 ts/s bw/2 bc/lt3 p/1 ioc/lt4"),
      showz: {},
    },
  }),
  nmlCmnz: () => ({
    iptStlz: {
      editz: a('bc/lt6 bw/2 br/0.5 dw/f tc/lt1 ts/m pv/0.5 ph/1 ioc/lt4'),
      showz: a('dw/f tc/lt1 ts/m pv/0.5 ph/1'),
    }
  }),
  outlined: () => ({
    iptStlz: {
      editz: a("sc/lt1 f/1 dh/f bc/lt3 br/0 brr/1 bw/2 tc/lt9 ts/m p/1 ioc/lt4"),
      showz: a("sc/t f/1 dh/f bc/t bw/2 tc/lt9 ts/m p/1"),
    },
  }),
};

export const iptMplAbtz = {
  nmlz: () => ({
    boxStlz: a("fd/rsc"),
    iptStlz: {
      editz: a(
        "dh/6 tc/lt9 ts/2 tf/system sc/lt2 bw/2 bc/lt3 br/1 p/1 ioc/lt5"
      ), // bEdit == true の場合
      showz: a("dh/6 tc/lt9 ts/2 tf/system sc/t bw/2 bc/0 p/1"), // bEdit == false の場合
    },
    iptPtyz: {},
  }),
};

export const lblAbtz: ht.dz = {

  nmlz: () => ({
    boxStlz: undefined,
    lblCz: {
      boxStlz: undefined,
      textz: {
        stlz: undefined,
      },
    },
    cttC: {
      boxStlz: undefined,
    },
  }),

  _barz: (pz?: { // underline
    bc?: ht.s,
    bwb?: ht.n,
    bwl?: ht.n,
//    dh?: ht.s | ht.n,
    dw?: ht.s | ht.n,
    fd?: ht.s,
    sc?: ht.s,
    tc?: ht.s,
  }) => {
    const _bc = pz?.bc ?? 'lt9';
    const _bwb = pz?.bwb ?? 0;
    const _bwl = pz?.bwl ?? 0;
//    const _dh = pz?.dh ?? 'n';
    const _dw = pz?.dw ?? 'f';
    const _fd = pz?.fd ?? 'rsc';
    const _sc = pz?.sc ?? 't';
    const _tc = pz?.tc ?? 'lt9';
    return {
//      boxStlz: a(`dw/f dh/${_dh}`),
      boxStlz: a(`dw/f`),
      lblCz: {
        boxStlz: a(`bc/${_bc} bwb/${_bwb} bwl/${_bwl} dw/${_dw} fd/${_fd} pv/0.5 ph/1 sc/${_sc}`),
        textz: {
          stlz: a(`tb tc/${_tc} ts/l`),
        }
      },
      cttCz: {
        boxStlz: a(`dw/f fd/css`),
      }
    }
  },

  _bandz: (pz: { // 廃止予定
    bc?: ht.s,
    bw?: ht.n,
    fd?: ht.s,
    sc?: ht.s,
    tc?: ht.s, 
  }) => {
    const _bc = pz?.bc ?? 't';
    const _bw = pz?.bw ?? 0;
    const _fd = pz?.fd ?? 'rsc';
    const _sc = pz?.sc ?? 'lt9';
    const _tc = pz?.tc ?? 'lt1';
    return {
      boxStlz: a(`bc/${_bc} bw/${_bw} dw/f`),
      lblCz: {
        boxStlz: a(`dw/f fd/${_fd} pv/0.5 ph/1.0 sc/${_sc}`),
        textz: {
          stlz: a(`tb tc/${_tc}`),
        }
      },
      cttCz: {
        boxStlz: a(`dw/f fd/css p/1`),
      },
    }
  },

  _ctdz: (pDz: { // 廃止予定
    ccd1: ht.s, 
    ccd2: ht.s
  }) => ({
    boxStlz: a(`br/1 dw/f sc/${pDz.ccd1} pt/1`),
    lblCz: {
      boxStlz: a(`pb/1 ph/1`),
      textz: {
        stlz: a(`tb tc/${pDz.ccd2}`),
      }
    },
    cttCz: {
      boxStlz: a(`dw/f fd/csc pb/1 ph/1`),
    }
  }),

/*
  _ulnz: (pz: { // underline
    bc: ht.s,
    tc: ht.s,
  }) => ({
    boxStlz: a('dw/f'),
    lblCz: {
      boxStlz: a(`bc/${pz.bc} bwb/2 pv/0.5 ph/1`),
      textz: {
        stlz: a(`tb tc/${pz.tc}`),
      }
    },
    cttCz: {
      boxStlz: a(`dw/f`),
    }
  }),
*/

  _hzlz: (pz?: { // horizontal
    bMpl?: ht.b,
    tc?: ht.s,
  }) => {
    const _fd = pz?.bMpl ? 'rss' : 'rsc';
    const _pt = pz?.bMpl ? 0.5 : 0;
    const _tc = pz?.tc ?? 'lt9';
    return {
      boxStlz: a(`dw/f fd/${_fd} pr/1`),
      lblCz: {
        boxStlz: a(`dw/15 pl/1 pr/0.5 pt/${_pt}`),
        textz: {
          stlz: a(`tb tc/${_tc} ts/m`)
        },
      },
      cttCz: {
        boxStlz: a('f/1 fd/rsc'),
      },
    }
  },

  _vclz: (pz?: { 
    tc?: ht.s 
  }) => {
    const _tc = pz?.tc ?? 'lt9';
    //hf.l(`_ca 791: ${_tc}`);
    return { // vertical
      boxStlz: a('dw/f fd/css'),
      lblCz: {
        boxStlz: a('dw/f fd/rsc'),
        textz: {
          stlz: a(`tb tc/${_tc} ts/m`)
        },
      },
      cttCz: {
        boxStlz: a('dw/f fd/rsc'),
      },
    };

  }
};

export const lineAbtz: ht.dz = {

  nmlz: () => ({
    boxStlz: undefined,
    cellCz: ( _nIdx: ht.n ) => ({
      boxStlz: undefined,
    })
  }),

  bdyCmnz: () => ({
    boxStlz: a('dh/f dw/f fd/rss'),
    cellCz: ( _nIdx: ht.n ) => ({
      boxStlz:
        _nIdx == 0 ?
          a('dh/f')
        : a('dh/f f/1')
    })
  }),

  cttCmnz: () => ({
    boxStlz: a('dh/f dw/f fd/csc'),
    cellCz: ( _nIdx: ht.n ) => ({
      boxStlz: 
        _nIdx == 1 ?
          a('dw/f fd/rac pv/0.5')
        : a('dw/f dwx/120 f/1 mh/a p/1'),
    })
  }),

};

export const linkAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a("fd/rss"),
    linkCz: {
      boxStlz: {},
      textz: {
        stlz: a("tu tb"),
      }
    },
    bfrCz: {
      boxStlz: a("pr/1"),
      textz: {
        stlz: {},
      },
    },
    atrCz: {
      boxStlz: a("pl/1"),
      textz: {
        stlz: {},
      },
    },
  }),
};

export const listAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: a(''),
    btnCz: {
      boxStlz: {
        nmlz: a("sc/lt3 fd/rac p/1"),
        sctz: a("sc/lt1"),
      },
      lblCz: {
        textz: {
          stlz: {
            nmlz: a("tb tc/lt5"),
            sctz: a("tb tc/lt9"),
          },
        },
      },
      bfrIconCz: {
        iconPtyz: {},
        boxStlz: {},
      },
      atrIconCz: {
        iconPtyz: {},
        boxStlz: {},
      },
    },
  }),

  menuCmnz: () => ({
    boxStlz: a('dh/f dw/8 fd/csc sc/lt7'),
    lz: {
      boxStlz: {
        nmlz: a('dh/8 dw/8 fd/ccc mb/2 pv/0.5 sc/lt7'), 
        sctz: a('dh/8 dw/8 fd/ccc mb/2 pv/0.5 sc/lt1')
      },
      lblCz: {
        boxStlz: a('dw/f fd/ccc'),
        textz: {
          stlz: {
            nmlz: a("tb tc/lt1 ts/xs"),
            sctz: a("tb tc/lt7 ts/xs"),
          },
        },
      },
      bfrIconCz: {
        iconPtyz: {
          nmlz: a("icc/lt1 ics/3"),
          sctz: a("icc/lt7 ics/3"),
        },
      }
    },
  }),

};

export const mdlAbtz = {
/*
  nmlz: () => ({
    boxStlz: a('sc/sk5 dh/dvc dw/dvc dp/a dz/mdl dt/0 dl/0'),
    maskz: {
      boxStlz: a('dp/a dz/mdl+1 dt/0 dl/0 dh/dvc dw/dvc'),
    },
    mainz: {
      boxStlz: a('sc/lt1 dp/a dz/mdl+2 dl/mdl dt/h db/h f/1, fd/ccc'),
    },
  })
*/
  nmlz: () => ({
    boxStlz: a('sc/sk5 dh/dvc dw/dvc dp/a dz/mdl dt/0 dl/0'),
    maskz: {
      boxStlz: a('dp/a dz/mdl+1 dt/0 dl/0 dh/dvc dw/dvc'),
    },
    mainz: {
      boxStlz: a('f/1 fd/ccc db/h dp/a dl/h dr/h dt/h dz/mdl+2 sc/lt1'),
    },
    btnz: {
//      boxStlz: a(`br/0.5 dh/4 dw/mdl fd/ccc mb/2 sc/lt5`),
      boxStlz: a(`br/0.5 dh/4 dw/mdl fd/ccc mb/2 sc/rd5`),
      textz: {
//        stlz: a(`tb tc/lt3 ts/s`),
        stlz: a(`tb tc/lt1 ts/m`),
      }
    }
  })
};

export const mdlCnfAbtz = {
  nmlz: () => ({
    boxStlz: a("sc/lt1 dwx/60 dwn/30 dw/f fd/csc fw/w p/1"),
    textCz: {
      boxStlz: a("dw/f fw/w"),
      textz: {
        stlz: a("ts/2 tc/lt5"),
        ptyz: a("tn/10"),
      },
    },
    btnz: {
      boxStlz: a('dw/f fd/rac mt/2 mb/1'),
//      btnCz: _btnAbtz.rnd18z(),
    },
  }),
};

export const mdlIptAbtz = {
  nmlz: () => ({
    boxStlz: a("sc/lt1 dw/f dwx/60 dwn/30 fd/csc fw/w p/1"),
  }),
};

/*
export const mdlMsgAbtz = {
  nmlz: () => ({
    boxStlz: a("sc/lt1 dwx/60 dwn/30 dw/f fd/csc fw/w p/1"),
    textCz: {
      boxStlz: a("dw/f fw/w"),
      textz: {
        stlz: a("ts/2 tc/lt5"),
        ptyz: a("tn/10"),
      }
    },
    btnz: {
      boxStlz: a('dw/f fd/rac mt/2 mb/1'),
    },
  }),
};
*/

export const msgAbtz: ht.dz = {
  nmlz: () => ({
//    boxStlz: a("sc/lt1 dw/60 p/1"),
    boxStlz: a("sc/lt1 dw/f"),
    lz: {
      boxStlz: a("fd/rss pv/0.5"),
      mkrCz: {
        boxStlz: a("dw/2 fd/ccc"),
        textz: {
          stlz: a("ts/2"),
          ptyz: a("tn/10"),
        },
      },
      msgCz: {
        boxStlz: a("f/1"),
        textz: {
          stlz: a("ts/2 fw/w"),
          ptyz: a("tn/10"),
        },
      },
    },
  }),

  _leftBdrCmnz: (pz: {
    ccd: ht.s
    bdrW: ht.n
  }) => ({
    boxStlz: a(`bc/${pz.ccd} bwl/${pz.bdrW} dw/f fd/ccc`),
    lz: {
      boxStlz: a("dw/f fd/rss"),
      mkrCz: {
        boxStlz: undefined,
        textz: {
          stlz: undefined,
        },
      },
      msgCz: {
        boxStlz: a("f/1 pl/2"),
        textz: {
          stlz: a(`tb tc/${pz.ccd} ts/l`),
          ptyz: a('tn/10'),
        },
      },
    },
  }),

  cttCmnz: () => ({
    boxStlz: a("dw/f fd/ccc"),
    lz: {
      boxStlz: a("dw/f fd/rss"),
      mkrCz: {
        boxStlz: undefined,
        textz: {
          stlz: undefined,
        },
      },
      msgCz: {
        boxStlz: a("f/1 pl/2"),
        textz: {
          stlz: undefined,
          ptyz: a('tn/10'),
        },
      },
    },
  }),

};

export const talkAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: {},
    lz: {
      boxStlz: a("pt/4"),
      atrz: {
        boxStlz: a("pt/1 pl/1"),
      },
      hdrz: {
        boxStlz: {},
        namez: {
          textz: {
            stlz: a("tb"),
          }
        },
        dtmz: {
          textz: {
            stlz: a("tc/lt4 ts/1.6 pl/1"),
          },
        },
      },
      msgz: {
        boxStlz: a("pt/1"),
        textz: {
          stlz: {},
          ptyz: a("tn/n")
        },
      },
    },
  }),

  taskCmnz: () => ({
    boxStlz: {},
    lz: {
      boxStlz: a("dw/f fd/rsc pt/4"),
      atrz: {
        boxStlz: a("pt/1 pl/1"),
      },
      hdrz: {
        boxStlz: a('dw/f fd/rsc'),
        namez: {
          textz: {
            stlz: a("tb tc/lt1 "),
          }
        },
        dtmz: {
          textz: {
            stlz: a("tc/lt4 ts/1.6 pl/1"),
          },
        },
      },
      msgz: {
        boxStlz: a("pt/1"),
        textz: {
          stlz: a('tc/lt1'),
          ptyz: a("tn/n")
        },
      },
    },
  }),

};

export const pnlAbtz: ht.dz = { // panell
  nmlz: () => ({
    boxStlz: a("f/1 dh/f"),
    hdrz: {
      boxStlz: a("dh/hdr dw/f fd/rsc pl/1"),
      textz: {
        stlz: a("tb"),
      }
    },
    bdyz: {
      boxStlz: a("dh/f dw/f sc/lt1"),
    },
    ftrz: {
      boxStlz: {}
    },
  }),
};

export const pnnAbtz: ht.dz = { // pagenation
  nmlz: () => ({
    boxStlz: a("dw/f fd/rec"),
    odrz: {
      boxStlz: a("dw/20 fd/rcc"),
      textz: {
        stlz: a("dw/5 dh/3 ts/1.6 fd/rec pt/0.35")
      },
      iptStlz: {
        editz: a("dh/3 dw/10 ts/1.6"),
        showz: a("dh/3 dw/10 ts/1.6"),
      },
    },
    linez: {
      boxz: a("dw/20 fd/rcc sc/t"),
      textz: {
        stlz: a("dw/5 dh/3 ts/1.6 sc/t fd/rec pt/0.35"),
      },
      iptStlz: {
        editz: a("dh/3 dw/10 ts/1.6"),
        showz: a("dh/3 dw/10 ts/1.6"),
      },
    },
    fstz: {
      boxStlz: a("pr/1"),
      iconPtyz: a("icn/angle-double-left ics/3"),
    },
    pvsz: {
      boxStlz: a("pr/1"),
      iconPtyz: a("icn/angle-left ics/3"),
    },
    nbrz: {
      textz: {  
        stlz: a("ts/2 dh/2.6 sc/t fd/ccc"),
      },
    },
    nextz: {
      boxStlz: a("pl/1"),
      iconPtyz: a("icn/angle-right ics/3"),
    },
    lastz: {
      boxStlz: a("pl/1"),
      iconPtyz: a("icn/angle-double-right ics/3"),
    },
  }),
};

export const rootAbtz: ht.dz = {

  nmlz: () => ({
    boxStlz: undefined,
    hdrCz: {
      boxStlz: undefined,
    },
    bdyCz: {
      boxStlz: undefined,
    },
    ftrCz: {
      boxStlz: undefined,
    },
  }),

  _dtpCmnz: (pDz: { ccd: ht.s }) => ({ // desktop
    boxStlz: a("dh/f dw/f"),
    hdrCz: {
      boxStlz: a(`dh/hdr dw/f sc/${pDz.ccd} dp/a dz/${cv.zIdxBdy} dt/0 dl/0`),
    },
    bdyCz: {
      boxStlz: a(`dh/bdy dw/f sc/${pDz.ccd} dp/a dz/${cv.zIdxBdy} dt/hdr dl/0`),
    },
  }),

};

export const schAbtz: ht.dz = {
  // search
  nmlz: () => ({
    boxStlz: a("fd/rec"),
    schFldz: {
      boxz: a("dw/25 fd/rcc sc/t"),
      textz: a("dw/10 dh/3 ts/1.6 sc/t fd/rec pt/0.35"),
      iptz: {
        editz: a("dh/3 dw/10 ts/1.6"),
        showz: a("dh/3 dw/10 ts/1.6"),
      },
    },
    btnCz: {
      boxStlz: a("pr/1"),
      bfrIconCz: {
        iconPtyz: a("icn/search ics/3")
      },
    },
  }),
};

export const sdrAbtz = {
  // slider
  nmlz: () => ({
    boxz: {},
    btnz: {
      boxz: {},
      textz: {
        boxz: {},
        pfxz: a("ts/2.4 tc/lt1"),
      },
    },
  }),
};

export const sprAbtz: ht.dz = { // swiper
  nmlz: () => ({
    boxStlz: a('dw/f f/1'),
  }),
};

export const srlAbtz: ht.dz = { // scroll
  nmlz: () => ({
    srlStlz: {
      otrz: a("dh/f dw/f"),
      inrz: a("f/1 dw/f fd/css"),
    },
    srlPtyz: undefined,
  }),
};

export const tblAbtz = {
  cttStfz: () => ({
    srlCz: {
      abtType: undefined,
    },
    boxCz: {
      abtType: undefined,
    },
    hdrCz: {
      abtType: undefined,
    },
    bdyCz: {
      abtType: undefined,
    }
  })
};

export const textAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: {},
    textz: {
      stlz: a(`tc/lt9 tf/system ts/m`),
//      ptyz: a(`tn/1`),
    },
  }),

  _lblz: (pz: { tc: ht.s }) => ({
    //boxStlz: a('pr/1'),
    textz: {  
      stlz: a(`tb tc/${pz.tc} ts/m`),
    },
  }),

  _lgnHdgCmnz: (pDz: { ccd: ht.s }) => ({
    boxStlz: undefined,
    textz: {
      stlz: a(`tb tc/${pDz.ccd ?? 'lt7'} ts/xxl`),
    },
  }),

  _rmkz: (pz?: {
    tc?: ht.s,
  }) => ({ // remark require
    boxStlz: undefined,
    textz: {
      stlz: a(`tb tc/${pz?.tc ?? 'lt9'} ts/xs`),
    }
  }),

  _tagCmnz: (pDz?: { ccd1?: ht.s, ccd2?: ht.s }) => ({
    boxStlz: a(`pv/0.5 ph/1 sc/${pDz?.ccd1 ?? 'rd5'}`),
    textz: {
      stlz: a(`tb tc/${pDz?.ccd2 ?? 'lt1'}`),
    }
  }),

  bsdCmnz: () => ({ // beside commons
    boxStlz: undefined,
    textz: {
      stlz: a('pl/0.5 pr/1.5'),
    },
  }),

  hdgz: () => ({ // headings
    boxStlz: a("dw/f bw/0 bc/lt4"),
    textz: {  
      stlz: a("dw/20 tb pv/1 ph/2 sc/lt4 tc/lt1 ta/c"),
    },
  }),

  listTtlCmnz: () => ({
    boxStlz: {},
    textz: {
      stlz: a('tb tc/lt1 ts/m'),
    },
  }),

  listCttCmnz: () => ({
    boxStlz: {},
    textz: {
      stlz: a('tc/lt1 ts/s'),
    },
  }),

  nmlCmnz: () => ({
    boxStlz: {},
    textz: {
      stlz: a('tc/lt1 ts/m'),
    },
  }),

  omtRqrCmnz: () => ({ // ornament require
    boxStlz: a('dp/a dt/0.25 dr/1.75'),
    textz: {
      pfx: '※',
      stlz: a('tb tc/rd5 ts/xs')
    }
  }),

/*
  rmkRqrCmnz: () => ({ // remark require
    boxStlz: a('dw/f fd/rec mb/1 pr/1'),
    textz: {
      pfx: '※：必須項目',
      stlz: a('tb tc/rd5 ts/xs'),
    }
  }),
*/

};

export const viewListAbtz: ht.dz = {
  nmlz: () => ({
    tblCz: {
      abtType: undefined,
    },
    hdrCz: {
      textCz: {
        abtType: undefined,
      }
    },
    bdyCz: {
      btnCz: {
        abtType: undefined,
      }
    }
  }),
};

export const viewDtlAbtz: ht.dz = {
  nmlz: () => ({
    crtz: {
      lblCz: {
        abtType: undefined,
      }
    },
    cldz: {
      tblCz: {
        abtType: undefined,
      },
      hdrCz: {
        textCz: {
          abtType: undefined,
        }
      },
      bdyCz: {
        btnDltCz: {
          abtType: undefined,
        },
        btnAddCz: {
          abtType: undefined,
        }
      }
    },
  }),
};

export const wireAbtz: ht.dz = {
  nmlz: () => ({
    boxStlz: {},
    textz: {
      stlz: a(`tc/lt9 tf/system ts/m`),
      ptyz: a(`tn/1`),
    },
  }),
};
